import { css } from '@emotion/react';
import { useContext } from 'react';
import { AngularContext } from 'react-app';
import type { RowProps } from 'shared/components/nv-table';
import NvTableCells from 'shared/components/nv-table/nv-table-cells';
import ClickableContainer from 'components/clickable-container';
import { MentoringProgramGuide } from 'redux/schemas/models/mentoring-program-guides';
import { gray7 } from 'styles/global_defaults/colors';
import AppearsInCell from './appears-in-cell';
import AudienceCell from '../../audience-cell';
import OptionsCell from './options-cell';
import TitleCell from './title-cell';
import { config } from '@config/pendo.config.json';
import { ColumnID } from './types';

export type { CellProps } from './types';

const cellMap = {
  [ColumnID.APPEARS_IN]: AppearsInCell,
  [ColumnID.TITLE]: TitleCell,
  [ColumnID.AUDIENCE]: AudienceCell,
  [ColumnID.OPTIONS]: OptionsCell,
};

const GuideRow = ({
  row,
  className,
  getCellStyle,
}: RowProps<MentoringProgramGuide>) => {
  const styles = css`
    height: 65px;

    &:hover {
      background-color: ${gray7};

      .options-target {
        opacity: 1;
      }
    }
  `;

  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);

  const handleRowClick = () => {
    const params = { guideId: row.original.id };
    $state.go($state.current, params, { notify: false });
  };

  return (
    <ClickableContainer
      css={styles}
      className={`align-content-center border-bottom border-gray-6 ${className}`}
      data-qa={`${config.pendo.athena.mentorshipProgram.guides.guideRow}_${row.original.id}`}
      onClick={handleRowClick}
    >
      <NvTableCells row={row} getCellStyle={getCellStyle} cellMap={cellMap} />
    </ClickableContainer>
  );
};

export default GuideRow;
